<template>
    <div class="content">
        <div class="left">
            <label class="writing-mode">монгол</label><br>
            <i class="el-icon-sort"></i><br>
            <label class="writing-mode">ᠮᠣᠩᠭᠣᠯ ᠪᠢᠴᠢᠭ</label><br>
            <el-button class="el-icon-check" @click="text1Blur"></el-button>
        </div>
        <div class="right">
            <el-card>
                <div class="xmw">
                    <textarea v-model="text1"/>
                </div>
                <div class="splice">
                    <el-divider direction="vertical"></el-divider>
                </div>
                <div class="jmw">
                    <div class="writing-mode" style="">
                        <div v-for="(s,index) in text2" :key="index">
                            {{s}}
                        </div>
                    </div>
                </div>
            </el-card>
        </div>
        <!--<el-row>
            <el-col :span="2">

            </el-col>
            <el-col :span="12">
                <label>基里尔蒙古文</label>
                <el-input type="textarea" v-model="text1" :rows="20" @blur="text1Blur" style="height: 540px;"></el-input>
            </el-col>
            <el-col :span="12">
                <label>传统蒙古文</label>
                <div class="writing-mode" style="width:calc(100% - 40px);height: 540px;border: 1px solid #C0C4CC;font-size: 18px;text-align: left;padding: 5px 15px;overflow-x:auto;">
                    <div v-for="(s,index) in text2" :key="index">
                        {{s}}
                    </div>
                </div>
            </el-col>
        </el-row>-->
    </div>
</template>

<script>
    import {trans} from "../api/index"
  //import {trans} from "../utils/trans";

  export default {
    name: 'HelloWorld',
    props: {
      msg: String
    },
    data() {
      return {
        text1: '',
        text2: []
      }
    },
    methods:{
      text1Blur(){
          const that = this
          that.text2 =[]
          trans(that.text1).then(response=>{
              response.data.split('\n').forEach(a=>{
                  that.text2.push(a)
              })
          }).catch((error)=>{
              console.log(error)
          })
        //this.text2 = trans(this.text1)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .content{
        padding: 10px 180px;

        .left{
            float: left;
            .writing-mode{
                background-color: #fff;
                padding: 30px 5px;
                border-radius: 5px;
                border: 1px solid #DCDFE6;
                margin: 0 0 20px 0;
                box-shadow: 0 2px 6px 0 #DCDFE6;
            }
            br+.writing-mode{
                margin: 20px 0 10px 0;
            }
            .el-button{
                width: 36px;
                padding: 10px 0;
                background-color: #01559A;
                color: #ffffff;
                font-weight: bold;
            }
        }
        .right{
            float: right;
            width: calc(100% - 46px);
            height: 650px;
            .el-card{
                height: 100%;
            }
            .xmw{
                width: calc(50% - 5px);
                height: calc(100% - 10px);
                float: left;
                textarea{
                    width: 100%;
                    height: 100%;
                    margin: 0;
                    padding: 0;
                    border: 0;
                    outline:none;
                    resize:none;
                }
            }
            .splice{
                width: 10px;
                height: calc(100% - 10px);
                float: left;
                .el-divider{
                    height: calc(100% - 60px);
                    margin: 20px 3px;
                }
            }
            .jmw{
                width: calc(50% - 5px);
                height: calc(100% - 10px);
                float: right;
                .writing-mode{
                    width: 100%;
                    height: 100%;
                    font-size: 18px;
                    text-align: left;
                    overflow-x:auto;
                    overflow-y:auto;
                }
            }
        }
    }
    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .el-col {
        padding: 20px;
    }
</style>
